// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-card-list{padding:10px}.content-card-list ul{list-style:none;padding:10px;margin-bottom:0}.content-card-list ul li{padding-left:0}@media only screen and (max-width: 768px){.content-card-list ul li{padding:0}}.content-card-list ul li.bordered{border-bottom:1px solid #e8ebf1}.content-card-list ul li a{display:inline-block;color:#727cf5;padding:10px 0;padding-right:10px !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
